import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import MaybeExternalLink from '../../common/MaybeExternalLink';

const HeaderNavLink = ({ surface, className, children, active, ...rest }) => {
  const maybeActiveProp = typeof active === 'boolean' ? { active } : {};

  return (
    <MaybeExternalLink
      className={classNames(
        'HeaderNavLink',
        'nav-link',
        `HeaderNavLink--${surface}`,
        className,
        { active }
      )}
      {...maybeActiveProp}
      {...rest}
    >
      {children}
    </MaybeExternalLink>
  );
};

HeaderNavLink.propTypes = {
  surface: PropTypes.oneOf(['top', 'bottom']).isRequired,
  className: PropTypes.string,
  children: PropTypes.node,
  active: PropTypes.bool,
};

HeaderNavLink.defaultProps = {
  className: '',
  children: null,
  active: undefined,
};

export default HeaderNavLink;
